module.exports = __webpack_public_path__ + "images/program/sacoche.a2201923.svg";